import API from "./api";

const operatorService = {
  getAll: async () => {
    const res = await API.get("/operators");
    return res.data;
  },

  create: async (data) => {
    const res = await API.post("/operators", data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await API.put(`/operators/${id}`, data);
    return res.data;
  },

  remove: async (id) => {
    const res = await API.delete(`/operators/${id}`);
    return res.data;
  },

  getFinancialSummary: async () => {
    const res = await API.get("/operator-payments/summary");
    return res.data;
  },

  getPayments: async (id) => {
    const res = await API.get(`/operator-payments/operator/${id}`);
    return res.data;
  },

  registerPayment: async (data) => {
    const res = await API.post("/operator-payments", data);
    return res.data;
  },
};

export default operatorService;
